import { useUser } from "utils/helpers/UserContext";
import PermissionForm from "./components/PermissionForm";
import { Authorities } from "props/authoritries";
import { SuperAdminStatusEnum } from '../../../../props/enum';

const HandleSetPermission: React.FC = () => {
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.CREATE_CMS_PERMISSION));
  if (isPermitted)
    return (
      <>
        <PermissionForm />
      </>
    );
  return <div className="text-primary-400 text-center h-[60vh] flex justify-center items-center">You don't have the permission.</div>;
};
export default HandleSetPermission;
